/**
 * Copa2026Logo — Emblema oficial do Bolão da Copa 2026.
 * Usa imagem WebP importada como asset estático (Vite resolve o path).
 */

import logoSrc from '@/assets/logo-copa2026.png';

interface Copa2026LogoProps {
  size?: number;
  className?: string;
}

export function Copa2026Logo({ size = 40, className }: Copa2026LogoProps) {
  return (
    <img
      src={logoSrc}
      alt="Bolão da Copa 2026"
      width={size}
      height={size}
      className={className}
      style={{ objectFit: 'contain' }}
      loading="eager"
    />
  );
}
